exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".qtyLabel {\n  width: 100%;\n  background: white;\n  border-radius: 5px;\n}\n.ui.input .react-datepicker-wrapper .react-datepicker__input-container input[type='text'].manage-order--date-picker {\n  width: 100%;\n}\n.messageText {\n  text-align: center;\n  color: red;\n}\n.cursorPointer {\n  cursor: pointer;\n}\n.datepickerClass {\n  width: 280px !important;\n}\n.content {\n  white-space: pre-wrap !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/inventory/manageprocessorder/index.less
// module id = 3384
// module chunks = 0